export const Menu = [];

/*** APP ITEMS */
Menu.push(
    {
        header: "Apps"
    },
    {
        title: "Level Progress",
        group: "apps",
        icon: "poll",
        name: "LevelProgress"
    },
    {
        title: "Users",
        group: "apps",
        icon: "mdi-account-multiple",
        name: "products"
    },
    {
        title: "Level Events",
        group: "apps",
        icon: "event",
        name: "LevelEvents"
    },
    {
        title: "Game Events",
        group: "apps",
        icon: "widgets",
        name: "GameItemEvents"
    },
    {
        title: "Shop Events",
        group: "apps",
        icon: "store",
        name: "ShopItemEvents"
    },
    {
        title: "User Log",
        group: "apps",
        icon: "info",
        name: "UserLog"
    },
    {
        title: "Level Progress Events",
        group: "apps",
        icon: "info",
        name: "LevelProgressEvents"
    },
);

/*** EXTRA ITEMS */
// Menu.push(
//     {
//         divider: true
//     },
//     {
//         header: "Inventory"
//     },
//     {
//         title: "Money-types",
//         group: "apps",
//         icon: "ballot",
//         name: "money-types"
//     },
//     {
//         title: "Item-types",
//         group: "apps",
//         icon: "ballot",
//         name: "item-types"
//     }
// );


Menu.forEach(item => {
    if (item.items) {
        item.items.sort((x, y) => {
            let textA = x.title.toUpperCase();
            let textB = y.title.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
    }
});
